import { motion } from "framer-motion";
import { ArrowUpRight, Play } from "lucide-react";

const HERO_IMG =
  "https://customer-assets-0z36b82j.emergentagent.net/job_web-forge-2354/artifacts/d5b5ae6c85d5d8fd_IMG_0184.jpeg";

export default function Hero({ content }) {
  return (
    <section id="top" className="relative min-h-screen flex items-end overflow-hidden" data-testid="hero">
      {/* Background portrait */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMG}
          alt="Mr Zee"
          className="w-full h-full object-cover object-top opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#09090b] via-[#09090b]/70 to-[#09090b]/30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#09090b]/80 via-transparent to-transparent" />
        <div className="absolute -left-10 top-1/3 w-[40vw] h-[40vw] bg-rose-600/20 blur-[120px] rounded-full" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 w-full pb-24 pt-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="flex items-center gap-3 mb-6"
        >
          <span className="flex gap-[3px] h-4 items-end">
            {[0, 1, 2, 3].map((i) => (
              <span key={i} className="eq-bar" style={{ animationDelay: `${i * 0.15}s` }} />
            ))}
          </span>
          <span className="font-mono text-xs tracking-[0.3em] uppercase text-rose-500" data-testid="hero-badge">
            {content.hero_badge}
          </span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
          className="font-anton uppercase text-white leading-[0.82] text-[22vw] sm:text-[18vw] lg:text-[16rem]"
          data-testid="hero-headline"
        >
          {content.hero_headline}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-6 max-w-xl text-zinc-300 text-base sm:text-lg leading-relaxed"
          data-testid="hero-tagline"
        >
          {content.hero_tagline}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="mt-10 flex flex-col sm:flex-row gap-4"
        >
          <a
            href="#sound"
            className="group inline-flex items-center justify-center gap-2 bg-rose-600 hover:bg-rose-500 text-white font-mono text-xs uppercase tracking-[0.15em] px-8 py-4 rounded-sm transition-colors shadow-[0_0_30px_rgba(225,29,72,0.35)]"
            data-testid="hero-listen-btn"
          >
            <Play className="w-4 h-4 fill-current" /> Listen to the music
          </a>
          <a
            href="#booking"
            className="group inline-flex items-center justify-center gap-2 border border-zinc-600 hover:border-white text-white font-mono text-xs uppercase tracking-[0.15em] px-8 py-4 rounded-sm transition-colors"
            data-testid="hero-book-btn"
          >
            Book Mr Zee <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
